import { createSelector } from 'reselect'

export function selectBase(state) {
  return state.crm.customFields
}

export function selectCustomFieldsById(state) {
  return selectBase(state).byId
}
export const selectCustomFields = createSelector(selectCustomFieldsById, byId =>
  Object.values(byId)
)

export const selectCustomFieldsByKey = createSelector(
  selectCustomFieldsById,
  customFields => {
    return Object.values(customFields).reduce((result, field) => {
      // eslint-disable-next-line no-param-reassign
      result[field.key] = field
      return result
    }, {})
  }
)

export function selectAllCustomFieldsIsLoading(state) {
  return selectBase(state).isLoading
}

export function selectCustomFieldForId(state, { id }) {
  return selectCustomFieldsById(state)[id]
}

export const selectCustomFieldForKey = createSelector(
  selectCustomFields,
  (state, { key }) => key,
  (fields, key) => {
    return fields.find(({ key: findKey }) => findKey === key)
  }
)
